import React from 'react';
import Styles from './Headline.module.less';
import { classes } from '../../../lib';

export type HeadlineProps = {
    titlePrefix: string;
    cyclingTexts: string[];
    titleSuffix?: string;
    labels: React.ReactNode;
    children: React.ReactNode;
    subtitle: string;
    video: React.ReactNode;
    buttons: React.ReactNode;
    buttonsDescription: string;
};

// eslint-disable-next-line max-lines-per-function
export const Headline = ({
    titlePrefix,
    cyclingTexts = [],
    titleSuffix,
    labels,
    video,
    buttons,
    buttonsDescription,
    subtitle,
    children,
}: HeadlineProps): JSX.Element => {
    return (
        <div className="vertical stretch-top g40 lp-section td-pt56 m-pt20">
            <div className={classes('vertical stretch-top g24', Styles.title)}>
                <div className={Styles.placeholderContainer}>
                    {
                        <>
                            <h1>
                                <span>
                                    {titlePrefix +
                                        (cyclingTexts.length > 0 ? ' ' : '')}
                                </span>
                                {cyclingTexts.length > 0 && (
                                    <span className={Styles.animationContainer}>
                                        <span>
                                            {cyclingTexts.map((text, key) => (
                                                <span key={key}>{text}</span>
                                            ))}
                                        </span>
                                    </span>
                                )}
                                {titleSuffix && (
                                    <>
                                        <br />
                                        {titleSuffix}
                                    </>
                                )}
                            </h1>
                            <h1
                                className={Styles.placeholder}
                                aria-hidden={true}>
                                <strong>--</strong>
                            </h1>
                        </>
                    }
                </div>

                <div className="td-hidden vertical stretch-top g20 semilarge-alude">
                    {children}
                </div>
                <div
                    className={classes(
                        Styles.labels,
                        'd-horizontal d-left-middle mt-vertical mt-stretch-top gx40 gy8 semilarge-alude'
                    )}>
                    {labels}
                </div>
            </div>
            <div>
                <div
                    className={classes(
                        Styles.headlineReverse,
                        'd-horizontal mt-vertical d-stretch-middle mt-stretch-top d-g80 mt-g40'
                    )}>
                    <div className={classes(Styles.videoContainer, 'd-flex-2')}>
                        {video}
                    </div>
                    <div className="vertical stretch-top g48 d-flex-1">
                        <div className="mt-hidden vertical stretch-top g20 semilarge-alude">
                            <h2 className={Styles.subtitle}>{subtitle}</h2>
                            {children}
                        </div>
                        <div className="vertical g8 strech-top">
                            <div className="td-horizontal m-vertical td-left-middle m-stretch-top g8 wrap">
                                {buttons}
                            </div>
                            <div className="vertical alude-gray-7 m-center-middle td-stretch-top">
                                {buttonsDescription}
                            </div>
                        </div>
                    </div>
                </div>
                <div className="d-hidden m-hidden vertical stretch-top g20 mt24 semilarge-alude">
                    <h2 className={Styles.subtitle}>{subtitle}</h2>
                    {children}
                </div>
            </div>
        </div>
    );
};
